import { qs, qsa, add, remove } from "@fluorescent/dom";
import { intersectionWatcher, delayOffset } from "@/lib/animation";
import { getMediaQuery } from "@/lib/media-queries";

const selectors = {
  divider: ".search__divider",
  partial: "[data-partial]",
  filterBar: "[data-filter-bar]",
  mobileFilterBar: "[data-mobile-filters]",
  productItems: ".animation--item:not(.animation--item-revealed)",
  stickyAnnouncement:
    ".announcement-bar:not([data-enable-sticky-announcement-bar='never'])",
  stickyHeader: ".header[data-enable-sticky-header='true']",
};

const classes = {
  hideProducts: "animation--search-products-hide",
  itemRevealed: "animation--item-revealed",
};

export default node => {
  const stickyAnnouncement = qs(selectors.stickyAnnouncement);
  const stickyHeader = qs(selectors.stickyHeader, document);
  const partial = qs(selectors.partial, node);
  const filterbarEl = qs(selectors.filterBar, node);
  const mobileFilterBarEl = qs(selectors.mobileFilterBar, node);
  let filterbarObserver = null;
  let mobileFilterBarObserver = null;

  if (filterbarEl) {
    filterbarObserver = intersectionWatcher(filterbarEl, true);
  }

  if (mobileFilterBarEl) {
    mobileFilterBarObserver = intersectionWatcher(mobileFilterBarEl, true);
  }

  _setupProductItem();

  function _setupProductItem() {
    let productItems = qsa(selectors.productItems, node);
    delayOffset(node, [selectors.productItems]);
    setTimeout(() => {
      add(productItems, classes.itemRevealed);
    }, 0);
  }

  // Scroll to top of search grid after applying filters
  // to show the newly filtered list of products
  function _scrollIntoView() {
    const divider = qs(selectors.divider, node);
    const dividerHeight = divider ? 1 : 0;
    let stickyAnnouncementHeight = 0;
    const stickyHeaderHeight = stickyHeader
      ? stickyHeader.getBoundingClientRect().height
      : 0;

    if (stickyAnnouncement) {
      if (
        (window.matchMedia(getMediaQuery("below-960")).matches &&
          stickyAnnouncement
            .getAttribute("data-enable-sticky-announcement-bar")
            .includes("mobile")) ||
        stickyAnnouncement
          .getAttribute("data-enable-sticky-announcement-bar")
          .includes("desktop")
      ) {
        stickyAnnouncementHeight =
          stickyAnnouncement.getBoundingClientRect().height;
      }
    }

    const y =
      partial.getBoundingClientRect().top +
      window.scrollY +
      dividerHeight -
      stickyAnnouncementHeight -
      stickyHeaderHeight -
      filterbarEl.getBoundingClientRect().height;

    window.scrollTo({ top: y, behavior: "smooth" });
  }

  function updateContents() {
    _setupProductItem();
    // Remove the fade out class
    remove(partial, classes.hideProducts);
    _scrollIntoView();
  }

  function infiniteScrollReveal() {
    _setupProductItem();
  }

  return {
    updateContents,
    infiniteScrollReveal,
    destroy() {
      filterbarObserver?.destroy();
      mobileFilterBarObserver?.destroy();
    },
  };
};
